import { ROUTER_PATHS as ROUTER_PATHS_USERCARE } from '../../../user-care/constant/constant';
import { ROUTER_PATHS as ROUTER_PATHS_DISTRIBUTION } from '../../../distribution/constant/router-contant';

// Identifier-based route map from API-provided menuIdentifier
export const IDENTIFIER_ROUTE_MAP: Record<string, string> = {
  // Overview
  OVERVIEW: '/userlogin/overview',
  // Support
  PRODUCTS_AND_SERVICES: '/userlogin/support/product',
  CUSTOMER_SUPPORT: '/userlogin/support/customerSupport',
  ONLINE_HELP: '/userlogin/support/onlineHelp',
  QUALITY_DOCUMENTS: '/userlogin/support/qualityDocuments',
  TOOLS_AND_TECH_INFO: '/userlogin/support/toolsInfo',
  NEWS_AND_EVENTS: '/userlogin/support/newsEvents',
  // Flight Info
  ALERTS_AND_NOTICES: '/userlogin/flight-info/alerts-and-notices',
  // CONTENT_AND_PROCEDURES: '/userlogin/flight-info',
  DATABASE_AND_MEDIATYPE: '/userlogin/flight-info/database-mediatype',
  EGPWS_TERRDB_SEARCH: '/userlogin/flight-info/egpws-search',
  // My Account
  MY_ACCOUNT: '/userlogin/my-account',
  PROFILE: '/userlogin/my-account/profile',
  SUBSCRIPTIONS: '/userlogin/my-account/subscription',
  SUBSCRIPTIONS_LIST: '/userlogin/my-account/subscription',
  DOWNLOAD_TRACKER: '/userlogin/my-account/download-tracker',
  PRIMUS_ELITE_OPTIONS: '/userlogin/my-account/primus-elite',
  // Databases
  INDS_DATABASES: '/userlogin/database',
  DOWNLOAD_DATABASE: '/userlogin/database/download',
  //   VIEW_DATABASE: '/userlogin/database',
  MY_DOWNLOADS: '/userlogin/database/admin-download',
  MY_DOWNLOADS_GUEST: '/guest/database/guest-download',
  // Subscriptions section
  ADD_PART2: '/userlogin/subscription/addpart2',
  MODIFY: '/userlogin/subscription/modify',
  EXCEPTIONS: '/userlogin/subscription/exception',
  ACTIVE: '/userlogin/subscription/active',
  EXPIRED: '/userlogin/subscription/expire',
  SEARCH_SUBSCRIPTION: '/userlogin/subscription/globalSearch',
  // User Care
  CONTACT_ADMINISTRATION: `${ROUTER_PATHS_USERCARE.USER_CARE}/${ROUTER_PATHS_USERCARE.Contact_Administration}`,
  INDS_SHARE: `${ROUTER_PATHS_USERCARE.USER_CARE}/${ROUTER_PATHS_USERCARE.Inds_Share}`,
  GUEST_ACCOUNT_MANAGEMENT: `${ROUTER_PATHS_USERCARE.USER_CARE}/${ROUTER_PATHS_USERCARE.Guest_Account}`,
  INDS_GUEST_ACCOUNT: `${ROUTER_PATHS_USERCARE.USER_CARE}/${ROUTER_PATHS_USERCARE.Guest_Account}`,
  TRACK_DOWNLOADS: `${ROUTER_PATHS_USERCARE.USER_CARE}/${ROUTER_PATHS_USERCARE.Track_Downloads}`,
  INDS_REPORTS: `${ROUTER_PATHS_USERCARE.USER_CARE}/${ROUTER_PATHS_USERCARE.Reports.reports}`,
  BROADCAST_MESSAGE_AND_PROMOTIONS: `${ROUTER_PATHS_USERCARE.USER_CARE}/${ROUTER_PATHS_USERCARE.BROADCAST_PROMOTIONS}`,
  OPERATOR_ADMIN: `${ROUTER_PATHS_USERCARE.USER_CARE}/${ROUTER_PATHS_USERCARE.Operator_Admin}`,
  MANAGE_USERS: `${ROUTER_PATHS_USERCARE.USER_CARE}/${ROUTER_PATHS_USERCARE.Operator_Admin}`,
  // Distribution
  DISTRIBUTION: `${ROUTER_PATHS_DISTRIBUTION.Distribution}`,
  CYCLE_DASHBOARD: `${ROUTER_PATHS_DISTRIBUTION.Distribution}/${ROUTER_PATHS_DISTRIBUTION.CycleDashboard}`,
  PACK_SLIP: `/userlogin/distribution/pack-slip`,
  GENARATE_AND_VIEW_PACKSLIP: `/userlogin/distribution/pack-slip`,
  GENERATE_VALIDATION_LETTERS: `${ROUTER_PATHS_DISTRIBUTION.Distribution}/${ROUTER_PATHS_DISTRIBUTION.ValidationLetter.GenerateValidationLetters}`,
  VIEW_SHIPMENT_SUMMARY: `${ROUTER_PATHS_DISTRIBUTION.Distribution}/${ROUTER_PATHS_DISTRIBUTION.ViewShipmentSummary}`,
  GENERATE_NAR: `${ROUTER_PATHS_DISTRIBUTION.Distribution}/${ROUTER_PATHS_DISTRIBUTION.Nar.GenerateNAR}`,
  BOM_SIMULATOR: `${ROUTER_PATHS_DISTRIBUTION.Distribution}/${ROUTER_PATHS_DISTRIBUTION.Bom}`,
};

export const SUBSCRIPTION_CHILD_KEYS: string[] = [
  'ADD_PART2', 'MODIFY', 'EXCEPTIONS', 'ACTIVE', 'EXPIRED', 'SEARCH_SUBSCRIPTION',
];


export const MODULE_LEVEL_ACCESS: Record<string, string> = {
  INDS_SUBSCRIPTIONS: '/userlogin/subscription',
  SUBSCRIPTIONS: '/userlogin/subscription',
  DISTRIBUTION: '/userlogin/distribution',
  INDS_DATABASES: '/userlogin/database',
  SUPPORT: '/userlogin/support',
  FLIGHT_INFO: '/userlogin/flight-info',
};

export const ASSOCIATED_ROUTES: Record<string, string[]> = {
  MANAGE_USERS: [
    '/userlogin/user-care/contact-add-user',
    '/userlogin/user-care/contact-edit-user',
  ],
  OPERATOR_ADMIN: [
    '/userlogin/user-care/contact-add-user',
    '/userlogin/user-care/contact-edit-user',
  ],
  CONTACT_ADMINISTRATION: [
    '/userlogin/user-care/contact-add-user',
    '/userlogin/user-care/contact-edit-user',
  ],
  GENERATE_NAR: [
    '/userlogin/distribution/view-nar',
    '/userlogin/distribution/edit-nar',
    '/userlogin/distribution/generate-nar-new-customer',
  ],
};

export const MODULE_BASE_PATHS = [
  '/userlogin/support',
  '/userlogin/flight-info',
  '/userlogin/database',
  '/userlogin/distribution',
  '/userlogin/subscription',
  '/userlogin/my-account',
  '/userlogin/user-care',
] as const;
